export enum MarketingStatus {
  ELIGIBLE = 'eligible',
  PRE_APPROVED = 'pre-approved',
  INELIGIBLE = 'ineligible',
}

export enum DecisionStatus {
  AUTO_APPROVED = 0,
  REFERRED = 1,
  DECLINED = 2,
}

export enum BrokerRoles {
  AGENT = 'User',
  MANAGER = 'Admin',
}

// eslint-disable-next-line prettier/prettier
export type brokerRoleTypes = `${BrokerRoles}`;

export interface ApplicationState {
  reference?: string;
  applicationId?: string;
  journeyProgress?: number | { [key: string]: number };
  decisionStatus?: DecisionStatus;
  marketingStatus?: MarketingStatus;
  maxQuoteLimit?: number;
  activeStep?: number;
  percentagePaidOff?: number;
  existingBalance?: number;
  brokerRole?: brokerRoleTypes;
}
